<div class="container">
  <nav aria-label="breadcrumb" style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb">
    <ol class="breadcrumb border-0 p-0">
      <li class="breadcrumb-item" aria-current="page">
        <a class=" text-decoration-none">
          <fa-icon icon="circle-info"></fa-icon>
          <span jhiTranslate="global.menu.infos.main">institutions</span>
        </a>
      </li>
      <li class="breadcrumb-item active text-secondary" aria-current="page">
        FAQ
      </li>
    </ol>
  </nav>

  <div id="list-example" class="list-group">
    <button type="button" class="list-group-item list-group-item-action" [ngbScrollSpyItem]="[spy, 'items-1']">
      sexcare – wofür steht das?
    </button>
    <button type="button" class="list-group-item list-group-item-action" [ngbScrollSpyItem]="spy" fragment="items-2">
      Was unterscheidet sexcare von anderen ähnlichen Seiten?
    </button>
    <button type="button" class="list-group-item list-group-item-action" [ngbScrollSpyItem]="spy" fragment="items-3">
      Wer steht hinter sexcare?
    </button>
    <button type="button" class="list-group-item list-group-item-action" [ngbScrollSpyItem]="spy" fragment="items-4">
      Was ist Sexualbegleitung?
    </button>
    <button type="button" class="list-group-item list-group-item-action" [ngbScrollSpyItem]="spy" fragment="items-5">
      Gibt es Erotik Angebot für Frauen?
    </button>
    <button type="button" class="list-group-item list-group-item-action" [ngbScrollSpyItem]="spy" fragment="items-6">
      Wie werde ich sexcare SexualbegleiterIn?
    </button>
    <button type="button" class="list-group-item list-group-item-action" [ngbScrollSpyItem]="spy" fragment="items-7">
      Für wen ist Sexualbegleitung?
    </button>
    <button type="button" class="list-group-item list-group-item-action" [ngbScrollSpyItem]="spy" fragment="items-8">
      Gibt es auch für homosexuelle Männer ein Angebot?
    </button>
    <button type="button" class="list-group-item list-group-item-action" [ngbScrollSpyItem]="spy" fragment="items-9">
      Wie kann ich mit einer sexcare Sexualbegleiterin oder Sexualbegleiter in Kontakt treten?
    </button>
    <button type="button" class="list-group-item list-group-item-action" [ngbScrollSpyItem]="spy" fragment="items-11">
      Sind die Fotos in den Profilen echt?
    </button>
  </div>
  <div ngbScrollSpy #spy="ngbScrollSpy" rootMargin="16px" class="bg-light p-3 rounded-2 mb-3" style="height: 500px">
    <h4 ngbScrollSpyFragment="items-1">sexcare – wofür steht das?</h4>
    <p>
      Sexcare wurde gegründet und entwickelt für die Suche und Buchung qualifizierter Sexualbegleitung. Durch
      professionelle Schulung und regelmässiges Coaching der Anbieter wird eine bedürfnisorientierte Begegnung
      sichergestellt. Den Institutionen und Beauftragten steht fachliche Unterstützung durch das eigens hierfür
      entwickelte <a href="{{baseUrl}}/institutions">Support Paket</a> zur Verfügung.
    </p>
    <h4 ngbScrollSpyFragment="items-2">Was unterscheidet sexcare von anderen ähnlichen Seiten?</h4>
    <p>
      Wir differenzieren uns ganz klar von gängigen Angeboten von Berührerinnen und Berührer. Unsere
      Sexualbegleiterinnen und Sexualbegleiter bieten eine interaktive - erotische Dienstleistung an und beschränken
      sich nicht nur auf Berührungen, noch machen sie ihr Angebot von Sympathie abhängig. Alle Damen und Herren, welche
      auf sexcare gelistet sind, haben nach einer erfolgreichen Bewerbung inkl. Sonderprivatauszug Schweizerisches
      Strafregister und entsprechendem Auswahlverfahren eine Schulung durchlaufen und werden fortlaufend gecoacht.
      Institutionen und Beauftragte profitieren von einer umfassenden Vorabklärung - <a
      href="{{baseUrl}}/institutions">Support Paket</a> - durch die Geschäftsführerin, Frau Isabelle
      Kölbl.
    </p>
    <h4 ngbScrollSpyFragment="items-3">Wer steht hinter sexcare?</h4>
    <p>
      Ein Unternehmen, projektiert, realisiert und geführt durch Isabelle Kölbl, eine der ersten Schweizer
      Sexualbegleiterinnen, ausgebildet von der renommierten Psychologin und Behindertenaktivistin
      <a
        href="https://www.hslu.ch/de-ch/soziale-arbeit/agenda/fachtagungen-kongresse/archiv/sexualaufklaerung/die-wuerde-ist-in-allen-lebensbereichen-unantastbar/"
        target="_blank">Dr.
        phil. Aiha Zemp</a>, Fachstelle für Behinderung und Sexualität. Frau Kölbl hat im Jahr 2011 das
      <a href="{{baseUrl}}/info/education">Schulungskonzept</a>für angehende Sexualbegleiter/innen wie auch
      die Plattform sexcare.ch zur Suche und Buchung von qualifizierter Sexualbegleitung aufgebaut. Ihre seit 2007
      gesammelten Praxis Erfahrungen und deren Interaktionen mit Institutionen und Beauftragten hat sie in Form von
      <a href="{{baseUrl}}/institutions">Fach- und Support Angeboten</a> eingebracht. Damit führt Frau Kölbl
      das Gedankengut der im Jahr 2011 verstorbenen Aiha Zemp fort. In der Vergangenheit unterstützte Isabelle Kölbl als
      Dozentin die FHSG im Modul <q>Sexualpädagogische Methodenvielfalt</q> und unterrichtete an der Stiftung OdA
      Gesundheit
      im Kanton Solothurn zum Kompetenzbereich <q>Abhängigkeit, Macht und Missbrauch in der Betreuung, Sexualität</q>,
      sowie
      aktuell an der FHNW zum Thema <q>Sexualität im Alter</q>.

    </p>
    <h4 ngbScrollSpyFragment="items-4">Was ist Sexualbegleitung?</h4>
    <p>
      Sexcare versteht unter Sexualbegleitung eine Form der aktiven Sexualassistenz, bei der die SexualbegleiterInnen
      über sexual- und behindertenpädagogische sowie pflegerische Kompetenzen verfügen. Das regelmässige Coaching gilt
      als wichtige Komponente bei den sexcare SexualbegleiterInnen. Insofern kann professionelle Sexualbegleitung auch
      von klassischer Prostitution abgegrenzt werden.
    </p>
    <h4 ngbScrollSpyFragment="items-5">Gibt es Erotik Angebot für Frauen mit Behinderung?</h4>
    <p>
      Selbstredend haben behinderte Frauen auch ein Recht, ihre Sexualität selbstbestimmt leben zu können. Im 2018 haben
      wir die erste Schulung für Sexualbegleiter durchgeführt und können seither auch der heterosexuellen Damen- und
      homosexuellen Herrenwelt die Möglichkeit anbieten, eine erfüllte Sexualität leben zu können. Wir agieren Gender
      neutral und bieten auch homosexuelle Begegnungen an. Dies wurde anlässlich der Podiumsdiskussion an der Rehab
      Basel im Februar 2014 von Betroffenen, wie auch von Fachleuten positiv aufgenommen.
    </p>
    <h4 ngbScrollSpyFragment="items-6">Wie werde ich sexcare Sexualbegleiter/in?</h4>
    <p>
      Sie haben Erfahrung im sozialen, pflegerischen oder therapeutischen Bereich und bezeichnen sich als offene und
      aufrichtige Persönlichkeit. Sozialkompetenz, Spass am Sex und ein herzliches Gemüt gehören zu Ihnen wie Luft zum
      Leben. Sie möchten als sexcare SexualbegleiterIn eine interaktive - erotische Dienstleistung anbieten und nicht
      nur Berührungen geben? Dann nehmen Sie mit uns <a href="www.sexcare.ch/info/education">Kontakt</a> auf, wir
      senden Ihnen
      gerne ausführliche Informationen zu.
    </p>
    <h4 ngbScrollSpyFragment="items-7">Für wen ist sexcare Sexualbegleitung?</h4>
    <p>
      Unser Angebot richtet sich an Menschen mit psychisch und/oder physisch eingeschränkten Möglichkeiten, an Menschen
      mit Dysfunktionen und Defiziten im Zusammenhang mit Sexualität. Zu unseren Gästen gehören Menschen mit
      Querschnittlähmung, MS, CP, OI, Autismus, Muskeldystrophie, kognitiver Behinderung, Demenz, Burn out Syndrom,
      Parkinson, erektiler Dysfunktion und vielen weiteren Krankheitsbildern, wie auch bei Defizit oder traumatischen
      Erlebnissen im sexuellen Bereich oder zur Überwindung sexueller partnerschaftlichen Problematiken im Sinne von
      Surrogatpartnerschaft.
    </p>
    <h4 ngbScrollSpyFragment="items-8">Gibt es auch für homosexuelle Männer ein Angebot?</h4>
    <p>
      Wir agieren Gender neutral und bieten auch homosexuelle Begegnungen an. Im 2018 haben wir die erste Schulung für
      Sexualbegleiter durchgeführt und können seither auch der homosexuellen Herrenwelt die Möglichkeit anbieten, eine
      erfüllte Sexualität leben zu können.
    </p>
    <h4 ngbScrollSpyFragment="items-9">Wie kann ich mit einer sexcare Sexualbegleiterin oder Sexualbegleiter in Kontakt
      treten?</h4>
    <p>
      Auf der Profilseite jeder Sexualbegleiterin und jedem Sexualbegleiter gibt es ein Kontaktknopf. Nach erfolgreicher
      Registration können Sie im geschützten sexcare Chatsystem Emojis oder Texte zusenden und erhalten.
    </p>
    <h4 ngbScrollSpyFragment="items-11">Sind die Fotos in den Profilen echt?</h4>
    <p>
      Das sexcare Team hat zu jeder Sexualbegleiterin oder jedem Sexualbegleiter persönlichen Kontakt und kann
      versichern, dass es sich bei den Fotos in den Profilen um Originalbilder handelt.
    </p>
  </div>
</div>
